import UmlShapeWidgetBase from './UmlShapeWidgetBase';
import './UmlSeqActivationWidget.css';

// Pure painter for UmlSeqActivationShape — the solid execution bar on a
// lifeline. Plain shape.x/y rendering — x is kept locked/derived from its
// participant (see UmlCanvasEngine.updateShapePosition); the bar CAN be
// dragged VERTICALLY to reposition it in the sequence. Holding SHIFT while
// dragging cascades the same dy to everything nested inside its own
// call\u2192return span (see CsSeqDiaRelationHandler.cascadeNestedSeqDiaShift),
// so a whole group of calls moves together instead of visually detaching;
// without Shift it's a normal standalone move. Own mousedown handler, NOT
// the shared handleDragMouseDown \u2014 that treats Shift as "toggle
// multi-selection" (see UmlShapeWidgetBasehandleDragMouseDownHelper.jsx),
// which would never even start a drag here. Also avoids Ctrl as the
// group-move key: Ctrl+mousedown already means "draw a connector" elsewhere
// and occasionally fired that instead (bug found 2026-07-19).
// Top/bottom resize handles enabled (see getDisabledHandles) to manually
// correct its length.
class UmlSeqActivationWidget extends UmlShapeWidgetBase {
    getDisabledHandles() {
        return ['nw', 'ne', 'sw', 'se', 'e', 'w']; // top/bottom (n/s) blijven aan — heuristiek voor de activatie-lengte is een benadering, gebruiker moet 'm kunnen bijstellen
    }

    getMinSize() {
        return { width: 10, height: 16 };
    }

    handleActivationMouseDown = (e) => {
        if (e.button !== 0) return;
        if (e.target.closest('.uml-resize-handle')) return;
        e.preventDefault();
        e.stopPropagation();

        const shape = this.props.shape;
        this.props.onShapeSelected?.(shape.id);
        this.props.onBringToFront?.(shape.id);

        const startWorld = this.props.toWorldPoint(e.clientX, e.clientY);
        const dragOffsetY = startWorld.y - shape.y;

        const onMouseMove = (ev) => {
            const worldPoint = this.props.toWorldPoint(ev.clientX, ev.clientY);
            const newY = worldPoint.y - dragOffsetY;
            this.props.onShapeMoved?.(shape.id, shape.x, newY, { shiftKey: ev.shiftKey });
        };
        const onMouseUp = () => {
            document.body.style.userSelect = '';
            document.body.style.cursor = '';
            window.removeEventListener('mousemove', onMouseMove, true);
            window.removeEventListener('mouseup', onMouseUp, true);
        };

        document.body.style.userSelect = 'none';
        document.body.style.cursor = 'grabbing';
        window.addEventListener('mousemove', onMouseMove, true);
        window.addEventListener('mouseup', onMouseUp, true);
    };

    render() {
        const shape = this.props.shape;
        return (
            <div
                className={`uml-seq-activation-widget${this.props.isSelected ? ' uml-selected' : ''}`}
                data-shape-id={shape.id}
                style={{ left: shape.x, top: shape.y, width: shape.w, height: shape.h, zIndex: this.props.stackIndex ?? shape.zIndex }}
                onMouseDown={this.handleActivationMouseDown}
            >
                {this.renderResizeHandles()}
            </div>
        );
    }
}

export default UmlSeqActivationWidget;
